module.exports = __webpack_public_path__ + "img/40_01_006_936.8295d8b3.jpg";